<template>
  <div class="home">
    <Desktop v-if="this.$store.state.device == 'desktop'" />
    <Mobile v-else />
  </div>
</template>

<script>
import Desktop from '../components/desktop/SchoolPosts.vue'
import Mobile from '../components/mobile/SchoolPosts.vue'

export default {
  name: 'Posts',

  components: {
    Desktop,
    Mobile,
  },


  data () {
    return {
      
    }
  },
  async asyncData ({ store, route: { params: { cid, pid }}}) {
    await store.dispatch("FETCH_COMMUNITIES", { id:cid })
    await store.dispatch('FETCH_COMMUNITIES_POSTS', { cid, pid })

    return store.dispatch("FETCH_COMMUNITIES", { id:cid }),store.dispatch('FETCH_COMMUNITIES_POSTS', { cid, pid })
  },
  created () {
  
  },

  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="stylus" scoped="">

</style>



// WEBPACK FOOTER //
// SchoolPostView.vue